module.exports = __webpack_public_path__ + "img/logo_unlogin@2x.6f796095.png";